module.exports = __webpack_public_path__ + "img/Estrellita-Non-select.170cfaee.svg";